<template>
  <div class="component-wrapper d-flex flex-column align-center mb-8">
    <div class="elevation-2">
      <div
        class="d-flex flex-md-row flex-column align-start mb-8 btn-container"
      >
        <v-tabs background-color="primary" class="flex-grow-0">
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab
            v-for="tab in tabs"
            :key="tab.id"
            :to="tab.path"
            class="white--text"
            active-class="active"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="flex-grow-1 d-flex flex-column align-center justify-center">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: "Περιοδοι Υποβολης",
          path: "/admin/periods",
        },

        {
          name: "Διαχειριστες Αμοιβαιων Κεφαλαιων",
          path: "/admin/employees",
        },

        {
          name: "Εργαζομενοι Επιτροπης Κεφαλαιαγορας",
          path: "/admin/hcmcemployees",
        },

        // {
        //   name: "ΕΚ VIEWER",
        //   path: "/admin/hcmcviewer",
        // },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  border: 1px solid var(--v-primary-base);
}

.btn-container {
  background-color: var(--v-primary-base);
}

@media only screen and (max-width: 960px) {
  .button {
    width: 100% !important;
  }
}

.active {
  // color: #004385 !important;
  background-color: #004385 !important;
}
</style>